import React from "react";
import "./Signup.css";
import logo from "./Media/vipps.png";
import FadeIn from "react-fade-in";

//Class to display "Hjelp" button on the seat reservation menu
//Shows modal of legend

export class InfoModal extends React.Component {
  render() {
    const info = (
      <div className="infoModal">
        <h3> Viktig informasjon om påmelding </h3>
        <br />
        <h6>Vi kan kun motta betaling med Vipps. </h6> <br />
        <h6>
          Når reservasjon er fullført må betalingen være registrert innbetalt
          senest innen 3 dager.
        </h6>
        <br />
        <h6>
          Om ikke innbetaling er registrert i tide, slettes påmeldingen for alle
          du melder på.
        </h6>
        <br />
        <h6>
          Reservasjon er bindende, og hvis du ikke betaler innen fristen kan vi
          utestenge deg for videre påmelding.
        </h6>
        <br />
        <p>Du kan melde på inntil 5 personer</p>
        <p>Du velger hvor i salen alle skal sitte</p>
        <img className="vippsLogo" src={logo} alt="Logo" />
      </div>
    );

    return (
      <div className="seatModal">
        <FadeIn>
          {info}
          <div className="btnSpace">
            <button
              className="btn btno btn-danger help"
              onClick={this.props.closeInfoModal}
            >
              {" "}
              Avbryt{" "}
            </button>
            <button
              className="btn btno btn-info help"
              onClick={this.props.startSignup}
            >
              Fortsett
            </button>
          </div>
        </FadeIn>
      </div>
    );
  }
}

export default InfoModal;



// WEBPACK FOOTER //
// ./src/Components/Signup/InfoModal.js